import React from 'react';
import {View} from 'react-native';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import {capitalizeFirstLetter} from '@/Utils/CommonUtils';
import customStyles from '../styles';

export const TimeClassPill = ({
  timeClass,
  timeControl,
}: {
  timeClass: string;
  timeControl?: string;
}) => {
  const styleMap: Record<string, {bg: string; text: string}> = {
    bullet: {bg: CCColors.GameReview.BlitzBg, text: CCColors.GameReview.Blitz},
    blitz: {bg: CCColors.GameReview.BlitzBg, text: CCColors.GameReview.Blitz},
    rapid: {bg: CCColors.GameReview.RapidBg, text: CCColors.GameReview.Rapid},
    classical: {
      bg: CCColors.GameReview.PurpleBg,
      text: CCColors.GameReview.Purple,
    },
  };
  const s = styleMap[timeClass?.toLowerCase()] ?? styleMap.rapid;
  return (
    <View style={[customStyles.tag, {backgroundColor: s.bg}]}>
      <CCText style={[customStyles.tagText, {color: s.text}]}>
        {capitalizeFirstLetter(timeClass)} {timeControl}
      </CCText>
    </View>
  );
};

export default TimeClassPill;
